<template>
  <div>
    <div class="container py-3">

      <div class="p-3 bg-white rounded shadow mb-5">

        <div class="row">
          <div class="col">

            <div class="d-flex mb-3">
              <h3 class="text-dark font-weight-bolder mr-auto mb-0"><span class="badge badge-pill badge-primary">Number of Visits</span>
              </h3>

              <div>
                <div class="input-group form-inline justify-content-between mt-2">
                  <label for="date-from" class="font-weight-bolder small mr-2">Date From:</label>
                  <input type="date" id="date-from" class="form-control form-control-sm form-control-xs rounded mr-2"
                         v-model="params.dateFrom">
                  <label for="date-to" class="font-weight-bolder small mt-1 mr-2 ml-3">Date To:</label>
                  <input type="date" id="date-to" class="form-control form-control-sm form-control-xs rounded mr-2"
                         v-model="params.dateTo">
                  <button class="btn btn-sm btn-xs btn-dark" @click="getManningReportVisits">
                    <font-awesome-icon icon="search"/>
                    Search
                  </button>
                </div>
              </div>
            </div>

            {{ authUser.company_id }}
            <table class="table table-bordered table-hover">
              <thead>
              <tr>
                <th scope="col">Nationality</th>
                <th scope="col">Manning</th>
                <th scope="col">Crew</th>
                <th scope="col">Staff</th>
                <th scope="col">Total</th>
              </tr>
              </thead>

              <tbody v-if="isLoading">
              <tr>
                <td colspan="100%">
                  <base-loader></base-loader>
                </td>
              </tr>
              </tbody>

              <tbody v-for="(nationality,index) in manningReports" :key="nationality.id" v-else>
              <tr>
                <td :rowspan="nationality.mannings.length + 1" style="vertical-align : middle;text-align:center;">
                  {{ nationality.natl }}
                </td>
              </tr>
              <tr v-for="(manning,manningIndex) in nationality.mannings" :key="manning.id">
                <td>{{ manning.alias }}</td>
                <td>{{ manning.crewCount }}</td>
                <td>{{ manning.staffCount }}</td>
                <td>{{ manning.totalCount }}</td>
              </tr>
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {AppMixins} from '@/mixins/app.mixins';
import Mannings from '../report1/Mannings';
import {DateService} from '@/service/date.service';

export default {
  name: 'ManningReport',

  /**mixins**/
  mixins: [AppMixins],

  components: {
    'mannings-table': Mannings,
  },

  /**data**/
  data() {
    return {
      params: {
        dateFrom: DateService.firstOfMonth(new Date(DateService.addMonth(new Date(), -1))),
        dateTo: DateService.lastOfMonth(new Date(DateService.addMonth(new Date(), -1))),

      },
    };
  },

  methods: {
    ...mapActions([
      'getManningReport',
    ]),

    async getManningReportVisits() {
      await this.getManningReport(this.params);
    },

  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
          'manningReports',
          'isLoading',
          'authUser',
        ],
    ),

  },

  created() {
    this.getManningReport(this.params);
  },

};
</script>

<style scoped>
/*For Footer use*/
.container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}


</style>
